import React, { useState, useEffect } from 'react';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const WhatsAppChat = () => {
  const [isOnline, setIsOnline] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);

  // Simulate online/offline status
  useEffect(() => {
    const interval = setInterval(() => {
      setIsOnline(Math.random() > 0.1); // 90% online probability
    }, 30000); // Check every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = '+919876543210'; // Resort contact number
    const message = encodeURIComponent(
      'Hi! I\'m interested in booking a stay at Dandeli Adventure Resorts. Could you please help me with availability and pricing?'
    );
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-40">
      <div 
        className="relative"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-card text-card-foreground text-sm rounded-lg shadow-organic-lg whitespace-nowrap">
            Chat with us on WhatsApp
            <div className="absolute top-full right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-card"></div>
          </div>
        )}

        {/* WhatsApp Button */}
        <Button
          variant="default"
          size="icon"
          onClick={handleWhatsAppClick}
          className="w-14 h-14 bg-[#25D366] hover:bg-[#20BA5A] text-white shadow-organic-lg pulse-gentle rounded-full"
        >
          <Icon name="MessageCircle" size={24} />
        </Button>

        {/* Online Status Indicator */}
        <div className={`absolute -top-1 -right-1 w-4 h-4 rounded-full border-2 border-background ${
          isOnline ? 'bg-success' : 'bg-muted-foreground'
        }`}>
          {isOnline && (
            <div className="w-full h-full bg-success rounded-full animate-ping opacity-75"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhatsAppChat;